<span class="relative flex flex-col w-full h-full min-h-6">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="flex items-center text-lg font-medium">
            <mat-icon class="icon-size-5 text-hint mr-2" svgIcon="mat_outline:insert_drive_file"></mat-icon>
            <span [innerHTML]="data.header"></span>
        </div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <div mat-dialog-content>
        <pdf-viewer
            id="pdfDocCanvas"
            style="display: block"
            [src]="data.pdfSrc"
            [original-size]="false"
            style="width: 100%; height: 800px; overflow: show"
        ></pdf-viewer>
    </div>
    <div>
        <div mat-dialog-actions style="margin-bottom: 0px !important">
            <button class="float-right mr-[20px]" (click)="downloadPdf(data.fileName, data.pdfSrc)" mat-flat-button [color]="'primary'">
                <mat-icon [svgIcon]="'heroicons_outline:document-download'"></mat-icon>
                <span class="ml-2 mr-1">{{ 'label_download' | translate }}</span>
            </button>
        </div>
    </div>
</span>
